import { makeStyles } from '@material-ui/core'

export const useListStyles = makeStyles(() => ({
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px var(--padding-md)',
    borderBottom: '1px solid var(--color-neutral-200)',
    backgroundColor: 'var(--color-neutral-050)'
  },
  recordCount: {
    fontSize: 'var(--text-size-xs)',
    fontWeight: 600,
    color: 'var(--color-neutral-400)',
    textTransform: 'uppercase',
    letterSpacing: '0.4px'
  },
  toolbarRight: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  searchInput: {
    padding: '5px 10px',
    border: '1px solid var(--color-neutral-300)',
    borderRadius: 'var(--border-radius-sm)',
    fontSize: 'var(--text-size-xs)',
    outline: 'none',
    width: '200px',
    backgroundColor: 'white',
    color: 'var(--color-neutral-900)',
    '&:focus': {
      borderColor: 'var(--color-primary-400)',
      boxShadow: '0 0 0 2px var(--color-primary-100)'
    },
    '&::placeholder': { color: 'var(--color-neutral-400)' }
  },
  filterSelect: {
    padding: '5px 10px',
    border: '1px solid var(--color-neutral-300)',
    borderRadius: 'var(--border-radius-sm)',
    fontSize: 'var(--text-size-xs)',
    outline: 'none',
    backgroundColor: 'white',
    color: 'var(--color-neutral-900)'
  },
  tableWrap: {
    '& .operational-table > thead > tr > th': {
      fontSize: 'var(--text-size-xs)',
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      color: 'var(--color-neutral-500)',
      padding: '10px 18px',
      borderBottom: '1px solid var(--color-neutral-200)'
    },
    '& .operational-table > thead': { backgroundColor: 'var(--color-neutral-050)' },
    '& .operational-table > tbody > tr > td': { padding: '10px 18px' }
  },
  mono: {
    fontFamily: 'var(--font-mono, monospace)',
    fontSize: 'var(--text-size-xs)'
  },
  enabledBadge: {
    display: 'inline-block',
    padding: '2px 8px',
    borderRadius: 'var(--border-radius-sm)',
    fontSize: 'var(--text-size-xs)',
    fontWeight: 600,
    backgroundColor: 'var(--color-success-050, #f0fdf4)',
    color: 'var(--color-success-700, #15803d)'
  },
  disabledBadge: {
    display: 'inline-block',
    padding: '2px 8px',
    borderRadius: 'var(--border-radius-sm)',
    fontSize: 'var(--text-size-xs)',
    fontWeight: 500,
    fontStyle: 'italic',
    backgroundColor: 'var(--color-neutral-050)',
    color: 'var(--color-neutral-400)'
  },
  warnBadge: {
    display: 'inline-block',
    padding: '2px 8px',
    borderRadius: 'var(--border-radius-sm)',
    fontSize: 'var(--text-size-xs)',
    fontWeight: 600,
    backgroundColor: 'var(--color-warning-050, #fefce8)',
    color: 'var(--color-warning-700, #a16207)'
  },
  actionBtn: {
    padding: 4,
    color: 'var(--color-neutral-300)',
    '&:hover': {
      color: 'var(--color-primary-600)',
      backgroundColor: 'var(--color-primary-050, #eff6ff)'
    }
  },
  dangerBtn: {
    padding: 4,
    color: 'var(--color-neutral-300)',
    '&:hover': {
      color: 'var(--color-danger-600, #dc2626)',
      backgroundColor: 'var(--color-danger-050, #fef2f2)'
    }
  },
  timestampText: {
    fontSize: 'var(--text-size-xs)',
    color: 'var(--color-neutral-400)'
  },
  newBtnWrap: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '6px 0'
  },
  emptyState: {
    padding: '48px 20px',
    textAlign: 'center'
  },
  emptyStateMessage: {
    fontSize: 'var(--text-size-sm)',
    color: 'var(--color-neutral-500)',
    marginBottom: '24px',
    lineHeight: 1.7
  }
}))
